import { SingleSourceTab } from "./SingleSourceTab";
import { PlaylistTab } from "./PlaylistTab";
import { MultiSourceTab } from "./MultiSourceTab";

import { SearchAndSelectTabProps } from "./SearchAndSelectTabProps";
import { SearchAndSelectSourceType } from "../SearchAndSelectSource";

export interface TabFactoryProps extends SearchAndSelectTabProps {
    sourceType: SearchAndSelectSourceType;
}

/**
 * Search and Select Tab Factory
 */
export const TabFactory = (props: TabFactoryProps) => {
    const { sourceType, ...rest } = props;

    switch (sourceType) {
        case SearchAndSelectSourceType.myMedia:
            return <SingleSourceTab {...rest} />;
            break;
        case SearchAndSelectSourceType.channel:
            return <SingleSourceTab {...rest} />;
            break;
        case SearchAndSelectSourceType.sharedRepository:
            return <SingleSourceTab {...rest} />;
            break;
        case SearchAndSelectSourceType.playlists:
            return <PlaylistTab {...rest} />;
            break;
        case SearchAndSelectSourceType.multiGalleries:
            return <MultiSourceTab {...rest} />;
            break;
    }
};
export default TabFactory;
